module.exports = __webpack_public_path__ + "img/125.72374f84.svg";